<template>
  <div>
    <!--Content_all-->
    <section class="content_all cont_int product_intern produc_c2">
      <Header></Header>
      <div class="wrapper_m">
        <section class="titulo">
          <h1>MARKETING</h1>
          <div class="tab_tittle right">
            <a href="marketing" class="active">
              <span>BTL/POP</span>
            </a>
            <a href="marketing-google">
              <span>Google</span>
            </a>
            <a href="marketing-facebook">
              <span>Facebook</span>
            </a>
            <a href="marketing-instagram">
              <span>Instagram</span>
            </a>
            <!--<a href="marketing-detail">Precio</a>-->
          </div>
        </section>
      </div>

      <!--Descripcion-->
      <section class="wrapper_m p_b_30">
        <ul class="detail_1">
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/btl/img1.jpg" />
              </div>
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt">
                  <h2 class="morado">
                    Materiales de promoción
                    <br />para tus canales
                  </h2>
                  <p>Elementos prácticos para el restaurante como servilletas, portavasos, tarjetas y demás, para promocionar os canales de venta online.</p>
                </div>
              </div>
            </section>
          </li>
          <li class="paddg block">
            <section class="flex">
              <div class="small-12 medium-6 large-5 columns">
                <div class="txt txt_right">
                  <h2 class="morado">
                    Campañas para la
                    <br />difusión de tu marca
                  </h2>
                  <p>Diseño de campañas en el contexto en para captar al público que quieres para tu restaurante.</p>
                </div>
              </div>
              <div class="small-12 medium-6 large-7 columns">
                <img src="assets/images/productos/marketing/btl/img4.jpg" />
              </div>
            </section>
          </li>
        </ul>
      </section>
      <!--Fin Descripcion-->
      <Footer></Footer>
    </section>
    <!--Fin Content_all-->
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Header,
    Footer
  }
}
</script>
